import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom'; // ✅ Correct Router usage
import { ThemeProvider, createTheme } from '@mui/material/styles';
import theme from './styles/theme'; // ✅ Ensure this file exports createTheme()
import './styles/styles.css';
import AppRoutes from './routes/Routes'; // ✅ Ensure correct component name

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AppRoutes /> {/* ✅ Corrected name */}
      </Router>
    </ThemeProvider>
  );
}

export default App;
